/* eslint-disable react/prop-types */
/* eslint-disable @typescript-eslint/no-explicit-any */
import { Box, Button, CircularProgress } from '@mui/material';
import {
 Dispatch,
 MutableRefObject,
 SetStateAction,
 useCallback,
 useEffect,
} from 'react';
import { useForm } from 'react-hook-form';
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';

import { usePage } from '../../../contexts/usePageContext';
import { useAppDispatch } from '../../../redux/hooks';
import * as resultsSlice from '../../../redux/results/resultsSlice';
import { RootState } from '../../../redux/store';
import { FormValues } from '../../../types/types';
import { findStructure } from '../../../utils/dataTypes';
import SelectApi from '../../common/SelectApi';
import { CustomGridApi } from '../../common/XTable/types';

const InfoMainEdit = ({
 apiRef,
 setIsEdit,
 id,
 car,
 driver,
 trailer,
}: {
 apiRef: MutableRefObject<CustomGridApi>;
 setIsEdit: Dispatch<SetStateAction<boolean>>;
 id: number;
 car: any;
 driver: any;
 trailer: any;
}) => {
 const dispatch = useAppDispatch();
 const { t } = useTranslation();
 const {
  handleSubmit,
  control,
  formState: { errors },
  setValue,
  register,
  reset,
  watch,
  trigger,
 } = useForm<FormValues>({
  mode: 'onChange',
  //   defaultValues: {
  //    brutoWeight,
  //    tareWeight,
  //   },
 });
 const { pageName } = usePage();
 const structure = useSelector((state: RootState) => state.results.structure);
 const success = useSelector((state: RootState) => state.results.success);
 const loading = useSelector((state: RootState) => state.results.loading);

 const isLoading = loading?.updateItem || loading?.getItem;

 const selects = useCallback(
  () =>
   !structure.length
    ? []
    : ['Driver', 'Car', 'Trailer1'].map((name) => {
       const structureItem = findStructure(structure, name);
       return {
        name,
        structure: structureItem,
        label: structureItem?.Translation || name,
       };
      }),
  [structure],
 )();
 //  console.log(structure, structure.length, selects, car, driver);

 const resetFields = () => {
  reset();
  setIsEdit(false);
 };

 const saveFields = (data: FormValues) => {
  console.log(data);
  const newValues = [
   {
    op: 'replace',
    path: `/Car/Id`,
    value: data?.Car?.Id,
   },
   {
    op: 'replace',
    path: `/Driver/Id`,
    value: data?.Driver?.Id,
   },
   {
    op: 'replace',
    path: `/Trailer1/Id`,
    value: data?.Trailer1?.Id,
   },
  ];

  dispatch(
   resultsSlice.updateItemStart({ table: pageName, id, data: newValues }),
  );
 };

 useEffect(() => {
  reset({
   Car: car,
   Driver: driver,
   Trailer1: trailer,
  });
  trigger('Car');
  trigger('Driver');
  trigger('Trailer1');
 }, []);

 useEffect(() => {
  if (success?.getItem) {
   resetFields();
   setIsEdit(false);
   //    apiRef.current.fetchData();
  }
 }, [success]);

 return (
  <Box
   component="form"
   onSubmit={handleSubmit(saveFields)}
   sx={{ display: 'flex', flexDirection: 'column', gap: 2, mb: 3 }}
  >
   {selects.map((select) => (
    <SelectApi
     key={select.name}
     name={select.structure.Name}
     url={select.structure.ForeignKeyUrl}
     filter={select.structure.ForeignKeyDefaultFilter}
     label={select.structure.Translation}
     isEditable={select.structure.IsEditable}
     operator="contains"
     control={control}
     setValue={setValue}
     disabled={isLoading || false}
    />
   ))}
   <Box sx={{ display: 'flex', justifyContent: 'flex-end', gap: 1 }}>
    <Button
     variant="text"
     color="secondary"
     disabled={isLoading || false}
     onClick={() => {
      resetFields();
     }}
    >
     {t('global.cancel')}
    </Button>
    <Button
     type="submit"
     variant="contained"
     disabled={isLoading || false}
     endIcon={
      isLoading ? <CircularProgress sx={{ color: 'white ' }} size={20} /> : null
     }
     // autoFocus
    >
     {t('global.apply')}
    </Button>
   </Box>
  </Box>
 );
};
export default InfoMainEdit;

